import * as React from 'react';
import { StoreState } from '../../redux/types';
import { FormData } from '@shopee/form-with-hook';

type RequireAuthKeyStateType = {
  state: {
    authKey: StoreState['authKey'];
  };
  isSubmitButtonDisabled: boolean;
  onSubmitForm: (formData: FormData, isValidForm: boolean) => Promise<void>;

  shouldDisableSubmit: boolean;
};

const defaultRequireAuthKeyState: RequireAuthKeyStateType = {
  state: {
    authKey: '',
  },
  isSubmitButtonDisabled: false,
  onSubmitForm: async () => {},
  shouldDisableSubmit: false,
};

export const SignupRequireAuthKeyContext = React.createContext<
  RequireAuthKeyStateType
>(defaultRequireAuthKeyState);

export const useSignupRequireAuthKeyContext = () => {
  const context = React.useContext(SignupRequireAuthKeyContext);
  return context;
};
